const fixCzechTypography = (text: string): string => {
	return (
		text
			// Add non-breaking space after single-letter prepositions
			.replace(/ (\b[aikouzvIKOUZV])\s+/g, ' $1\u00A0')
			// Add non-breaking space after multi-letter prepositions
			.replace(/\b(ve|na|u|s|k|o|po|před)\s+/gi, '$1\u00A0')
			// Add non-breaking space after numbers followed by a period
			.replace(/(\d+\.)\s+/g, '$1\u00A0')
			// Add non-breaking space after standalone numbers
			.replace(/(\d+)\s+/g, '$1\u00A0')
			// Add non-breaking space before certain punctuation (exclude colon and dash)
			.replace(/\s([,.?!])/g, '\u00A0$1')
			// Replace hyphen with non-breaking hyphen in numeric ranges
			.replace(/(\d+)-(\d+)/g, '$1\u2011$2')
			// Add non-breaking space before dash only if it's not part of a range
			.replace(/(?<!\d)\s-/g, '\u00A0-')
			// Add non-breaking space after colon in specific patterns (e.g., "Část 1: Složení")
			.replace(/(\w+\s+\d+):\s+(\w+)/g, '$1:\u00A0$2')
	)
}

export const fixCzechTypographyText = fixCzechTypography
